import script from "./KeepThis.vue?vue&type=script&setup=true&lang=js"
export * from "./KeepThis.vue?vue&type=script&setup=true&lang=js"

import "./KeepThis.vue?vue&type=style&index=0&id=9dd0127c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dd0127c"]])

export default __exports__